import { ReactElement, useEffect } from 'react';
import { useModalService } from 'hooks/useModalService';
import { ModalVariant } from 'types/Modal';
import { PageSpinner } from 'components/atoms/PageSpinner';

export const BetaWallPage = (): ReactElement => {
  const { show: showModal, activeModal } = useModalService();
  useEffect(() => {
    if (activeModal !== ModalVariant.BETA_WALL) {
      showModal(ModalVariant.BETA_WALL);
    }
  }, [showModal, activeModal]);

  return <PageSpinner />;
};
